export const colors = {
  // Primary Brand Colors
  primary: '#003A9F', // Navy Blue
  primaryLight: '#1a5bc2', // Lighter Navy
  primaryDark: '#002a75', // Darker Navy
  
  accent: '#EF7E15', // Orange
  accentLight: '#f29943', // Light Orange
  accentDark: '#d16b0c', // Dark Orange
  
  // Neutral Colors
  white: '#ffffff',
  black: '#0f172a',
  gray50: '#f8fafc',
  gray100: '#f1f5f9',
  gray200: '#e2e8f0',
  gray300: '#cbd5e1',
  gray400: '#94a3b8',
  gray500: '#64748b',
  gray600: '#475569',
  gray700: '#334155',
  gray800: '#1e293b',
  
  // Semantic Colors
  background: '#ffffff',
  backgroundAlt: '#f8fafc',
  text: '#0f172a',
  textSecondary: '#475569',
  border: '#e2e8f0',
  
  // Interactive States
  hover: '#002a75',
  focus: '#EF7E15'
};
